import React from 'react';
import { Route, Switch } from 'react-router-dom';

import * as Login from './index';

export const routes = [
    {
        exact: true,
        path: '/login',
        component: Login.LoginIndex,
    },
    {
        exact: true,
        path: '/login/email',
        component: Login.LoginEmail,
    },
    {
        exact: true,
        path: '/login/password',
        component: Login.LoginPassword,
    },
    {
        exact: true,
        path: '/login/reset',
        component: Login.LoginReset,
    },
    {
        exact: true,
        path: '/login/validate',
        component: Login.LoginValidate,
    },
];

export const LoginRoutes = props => (
    <Switch>
        {routes.map(r => {
            const Component = r.component || React.createComponent(r.toRender);
            const routeProp = { ...r, component: undefined };
            return <Route key={r.path} {...routeProp} render={() => <Component {...props} />} />;
        })}
    </Switch>
);
export default LoginRoutes;
